// extracted by mini-css-extract-plugin
export default {"main":"treatmentPage_main__gHce1"};